import TableColumn, { ITableColumn } from './TableColumn';

export type { ITableColumn };
export default TableColumn;
